import { useState, useRef } from 'react';

interface UseVirtualScrollOptions {
  itemHeight: number; // 每个选项的高度
  visibleCount: number; // 可见区域显示的选项数量
  totalCount: number; // 总选项数量
}

interface UseVirtualScrollReturn {
  visibleItems: number[]; // 可见区域的索引范围
  paddingTop: number; // 顶部占位高度
  paddingBottom: number; // 底部占位高度
  containerProps: {
    ref: React.RefObject<HTMLDivElement>;
    onScroll: (e: React.UIEvent<HTMLDivElement>) => void;
    style: React.CSSProperties;
  };
  resetScroll: () => void;
}

export const useVirtualScroll = ({
  itemHeight,
  visibleCount,
  totalCount,
}: UseVirtualScrollOptions): UseVirtualScrollReturn => {
  const [scrollTop, setScrollTop] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  // 计算可见区域的起始和结束索引
  const startIndex = Math.floor(scrollTop / itemHeight);
  const endIndex = Math.min(startIndex + visibleCount, totalCount - 1);
  // 占位元素的高度
  const paddingTop = startIndex * itemHeight;
  const paddingBottom = (totalCount - endIndex - 1) * itemHeight + 6;

  // 滚动事件处理
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    setScrollTop(e.currentTarget.scrollTop);
  };

  const resetScroll = () => {
    setScrollTop(0);
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  };

  return {
    visibleItems: Array.from(
      { length: endIndex - startIndex + 1 },
      (_, i) => startIndex + i,
    ),
    paddingTop,
    paddingBottom,
    resetScroll,
    containerProps: {
      ref: containerRef,
      onScroll: handleScroll,
      style: {
        maxHeight: `${visibleCount * itemHeight}px`,
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
  };
};
